import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { SmallInfoCard } from '@bloomays-lib/ui.shared';
import { GqlTalentBoardEventKpis } from '@bloomays-lib/types.shared';

type EventsKpisProps = {
  kpis: GqlTalentBoardEventKpis | null;
  loading: boolean;
};

const EventsKpis = ({ kpis, loading }: EventsKpisProps): ReactNode => {
  const { t } = useTranslation(['talentBoard']);

  return (
    <KpisContainer>
      <SmallInfoCard
        iconName="people"
        title={t('eventsDashboard.kpis.clientVisits')}
        value={String(kpis?.talentBoardOpened ?? 0)}
        loading={loading}
      />
      <SmallInfoCard
        iconName="people"
        title={t('eventsDashboard.kpis.talentsViewed')}
        value={String(kpis?.talentViewed ?? 0)}
        loading={loading}
      />
      <SmallInfoCard
        iconName="chat"
        title={t('eventsDashboard.kpis.comments')}
        value={String(kpis?.commentUpserted ?? 0)}
        loading={loading}
      />
    </KpisContainer>
  );
};

const KpisContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '24px',
}));

export default EventsKpis;
